import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Edit, Trash2 } from "react-feather";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../../Baseurl";

const BlogAddCategory = () => {
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [editId, setEditId] = useState(null);

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${baseurl}GetAllBlogCategories`);
      setCategories(res.data.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleShowModal = (category = null) => {
    if (category) {
      setCategoryName(category.name);
      setEditId(category.id);
    } else {
      setCategoryName("");
      setEditId(null);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCategoryName("");
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        // Update category
        const res = await axios.post(`${baseurl}UpdateBlogCategory/${editId}`, {
          name: categoryName,
        });
        if (res.status === 200) {
          Swal.fire("Updated!", "Category updated successfully.", "success");
          fetchCategories();
          handleCloseModal();
        }
      } else {
        // Add category
        const res = await axios.post(`${baseurl}AddBlogCategory`, {
          name: categoryName,
        });
        if (res.status === 201) {
          Swal.fire("Added!", "Category added successfully.", "success");
          fetchCategories();
          handleCloseModal();
        }
      }
    } catch (error) {
      console.error("Error saving category:", error);
      Swal.fire("Error!", "An error occurred.", "error");
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}DeleteBlogCategory/${id}`);
          Swal.fire("Deleted!", "Category has been deleted.", "success");
          fetchCategories();
        } catch (error) {
          console.error("Error deleting category:", error);
          Swal.fire("Error!", "Failed to delete category.", "error");
        }
      }
    });
  };

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    { name: "Category Name", selector: (row) => row.name, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button className="btn btnedit me-2" onClick={() => handleShowModal(row)}>
            <Edit size={16} />
          </button>
          <button className="btn btndelete" onClick={() => handleDelete(row.id)}>
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Blog Categories</h4>
            <button className="addbtn" onClick={() => handleShowModal()}>
              Add Blog Category
            </button>
          </div>

          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={categories}
              pagination
              highlightOnHover
              responsive
            />
          </div>

          {/* Modal */}
          {showModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {editId ? "Edit Category" : "Add Category"}
                    </h5>
                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3 text-start">
                        <label htmlFor="name" className="form-label">
                          Category Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter Category Name"
                          value={categoryName}
                          onChange={(e) => setCategoryName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="text-end">
                        <button type="submit" className="btn submitbtnn">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default BlogAddCategory;
